module.exports = __webpack_public_path__ + "fonts/Rubik-500-hebrew73.bda074a.woff2";